import React from "react";

function Footer() {
  return (
    <div className="w-full absolute container-fluid p-8">
      <h3 className="text-[#262740] text-center">
        Copyright © 2023 Ciphers.me
      </h3>
      <p className="text-[#262740] text-center text-subtleText"><a href="mailto:contact@ciphers.me">contact@ciphers.me</a></p>
    </div>
  );
}

export default Footer;
